import { useCurrentAuction } from "./useCurrentAuction";

const useCurrentAuctionHourId = () => {
  const auction = useCurrentAuction();
  return auction?.hourId;
}

export { useCurrentAuctionHourId }